<template>
        <div class="table__responsive">
            <table class="table table__responsive">
                <thead>
                    <tr>
                        <th>{{$t('dashboard.applications.attachments_table.header.attachment')}}</th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!applicationAttachments.length" :key="'no-attachments'" class="table--empty">
                        <td colspan="3">
                            <div class="text-center">{{$t('dashboard.applications.attachments_table.no_attachments')}}</div>
                        </td>
                    </tr>
                    <template v-else>
                        <tr v-for="(attachment, index) in applicationAttachments" :key="attachment.name + index">
                            <td>{{ attachment.name }}</td>
                            <td><span @click="downloadAttachment(attachment)" v-tooltip.bottom="$t('dashboard.applications.attachments_table.download')" class="table__icon icons icon-cloud-download"></span></td>
                            <td><span @click="showDeleteDocumentModal(attachment)" v-tooltip.bottom="$t('dashboard.applications.attachments_table.delete')" class="table__icon icons icon-trash"></span></td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch } from 'vue-property-decorator';
    import { saveFile } from '@/helpers';
    import ApplicationAttachment from '@/models/ApplicationAttachment';
    import { GET_APPLICATIONS } from '@/store/modules/applications';


    @Component
    export default class ApplicationAttachmentsTable extends Vue {
        @Prop()
        application;

        applicationAttachments = [];
        mounted() {
            this.mapApplicationAttachments();
        }

        // Deeply watch changes of the application object and map the files to models.
        @Watch('application', { deep: true })
        mapApplicationAttachments() {
            this.applicationAttachments = this.application.files.map(file => {
                let attachment = ApplicationAttachment.makeModel(`/trajectories/${this.trajectory.id}/applications/${this.application.id}/files`);
                return attachment.fromJson(file);
            });
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        documentTooltipContent(attachment) {
            return this.$t('dashboard.documents.versions_table.document_info', { sender: attachment.uploader.name, date: attachment.date});
        }

        downloadAttachment(attachment) {
            const url = `/trajectories/${this.trajectory.id}/applications/${this.application.id}/files/${attachment.id}`;
            return this.axios.get(url, {responseType: 'blob'})
                .then(
                    res => saveFile(res.data, attachment.name, attachment.mime),
                    err => this.$notify.error(this.$t('notify.download_error')));
        }

        showDeleteDocumentModal(attachment) {
            const content = {
                title: this.$t('modals.delete_application_attachment.title'),
                message: this.$t('modals.delete_application_attachment.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteDocument, attachment});
        }

        deleteDocument({attachment}) {
            attachment.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.application_attachment.delete_success'));
                    const fileIndex = this.application.files.findIndex(file => file.id === attachment.id);
                    this.application.files.splice(fileIndex, 1);
                    this.$store.dispatch(GET_APPLICATIONS, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.application_attachment.delete_error')));
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/ApplicationAttachmentsTable.vue